import { FC } from 'react';

import { ClickAwayListener, Grow, Paper, Popper } from '@mui/material';

import { useShallow } from 'zustand/react/shallow';

import { AdvertisingPackageResponse, SpaceResponse } from '@/api/data-contracts';
import useGeneratikTableStore from '@/shared/ui/GeneratikTable/generatikTableStore';

import ShoppingCartContent from './ShoppingCartContent';
import ShoppingCartEmpty from './ShoppingCartEmpty';

interface Props {
  anchorEl: HTMLButtonElement | null;
  handleClose: () => void;
}

const ShoppingCartPopover: FC<Props> = ({ anchorEl, handleClose }) => {
  const { selectedSpaces, selectedPackages } = useGeneratikTableStore(
    useShallow((state) => {
      return {
        selectedSpaces: (state.selectedRows['ADVERTISING_SPACES'] ?? []) as SpaceResponse[],
        selectedPackages: (state.selectedRows['ADVERTISING_PACKAGES'] ??
          []) as AdvertisingPackageResponse[],
      };
    }),
  );

  return (
    <Popper
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      placement="right-end"
      transition
      sx={{ zIndex: 1300 }}
    >
      {({ TransitionProps }) => (
        <ClickAwayListener onClickAway={handleClose}>
          <Grow {...TransitionProps} timeout={350}>
            <Paper data-testid="shopping-cart-drawer">
              {!selectedSpaces.length && !selectedPackages.length ? (
                <ShoppingCartEmpty handleClose={handleClose} />
              ) : (
                <ShoppingCartContent handleClose={handleClose} />
              )}
            </Paper>
          </Grow>
        </ClickAwayListener>
      )}
    </Popper>
  );
};

export default ShoppingCartPopover;
